import {
  QUERY_BUILDER_KEYWORD_ENTITY_KEY,
  QueryBuilderEntityConfigType,
} from '../../types';

export const getQueryBuilderEntitiesWithKeyword = (
  entities: QueryBuilderEntityConfigType[],
  keywordLabel: string
): QueryBuilderEntityConfigType[] => {
  return [
    ...entities,
    {
      key: QUERY_BUILDER_KEYWORD_ENTITY_KEY,
      label: keywordLabel,
      color: '#E9ECEF',
      loadValues: async () => [],
    },
  ];
};
